import { render, staticRenderFns } from "./ClickToRun.vue?vue&type=template&id=48294fd6&scoped=true&"
import script from "./ClickToRun.vue?vue&type=script&lang=js&"
export * from "./ClickToRun.vue?vue&type=script&lang=js&"
import style0 from "./ClickToRun.vue?vue&type=style&index=0&id=48294fd6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48294fd6",
  null
  
)

export default component.exports